/* RD CUSTOMZ: corroborate a remembered market with fresh location signals.
   No exchange rates, GPS, IP storage or analytics. Shopify renders all prices. */
(function (root) {
  'use strict';
  const VERSION = '2026-09-27.1';
  const zones = {
    'Europe/Amsterdam':['NL'], 'Europe/Brussels':['BE'], 'Europe/Luxembourg':['LU'],
    // Some browsers canonicalize these IANA links to Berlin. Treat them as compatible, not as proof of Germany.
    'Europe/Berlin':['DE','NL','DK','LU','NO','SE'], 'Europe/Copenhagen':['DK'], 'Europe/Stockholm':['SE'],
    'Europe/Oslo':['NO'], 'Europe/Helsinki':['FI'], 'Europe/Paris':['FR'], 'Europe/London':['GB'],
    'Europe/Dublin':['IE'], 'Europe/Zurich':['CH','LI'], 'Europe/Vienna':['AT'], 'Europe/Rome':['IT'],
    'Europe/Madrid':['ES'], 'Atlantic/Canary':['ES'], 'Europe/Lisbon':['PT'], 'Atlantic/Azores':['PT'], 'Atlantic/Madeira':['PT'],
    'Europe/Warsaw':['PL'], 'Europe/Prague':['CZ','SK'], 'Europe/Bratislava':['SK'],
    'Europe/Budapest':['HU'], 'Europe/Bucharest':['RO'], 'Europe/Sofia':['BG'],
    'Europe/Zagreb':['HR'], 'Europe/Ljubljana':['SI'], 'Europe/Belgrade':['RS','HR','SI','BA','ME','MK'],
    'Europe/Vilnius':['LT'], 'Europe/Riga':['LV'], 'Europe/Tallinn':['EE'], 'Europe/Athens':['GR'],
    'Europe/Malta':['MT'], 'Europe/Kyiv':['UA'], 'Europe/Kiev':['UA'],
    'Asia/Tokyo':['JP'], 'Asia/Seoul':['KR'], 'Asia/Hong_Kong':['HK'], 'Asia/Singapore':['SG','MY'],
    'Asia/Kuala_Lumpur':['MY'], 'Asia/Kuching':['MY'], 'Asia/Dubai':['AE','OM'], 'Asia/Jerusalem':['IL'],
    'America/New_York':['US'], 'America/Chicago':['US'], 'America/Denver':['US'], 'America/Los_Angeles':['US'],
    'America/Phoenix':['US'], 'America/Anchorage':['US'], 'Pacific/Honolulu':['US'],
    'America/Toronto':['CA'], 'America/Vancouver':['CA'], 'America/Edmonton':['CA'], 'America/Winnipeg':['CA'],
    'America/Halifax':['CA'], 'America/St_Johns':['CA'], 'America/Regina':['CA'],
    'Australia/Sydney':['AU'], 'Australia/Melbourne':['AU'], 'Australia/Perth':['AU'],
    'Australia/Brisbane':['AU'], 'Australia/Adelaide':['AU'], 'Australia/Hobart':['AU'], 'Australia/Darwin':['AU'],
    'Pacific/Auckland':['NZ'], 'Pacific/Chatham':['NZ']
  };
  function decide({current, shopify, cloudflare, timeZone, available, manual}) {
    const offered = code => available.includes(code);
    if (manual && offered(manual)) return {action:manual === current ? 'keep' : 'switch', country:manual, reason:'manual'};
    const tz = zones[timeZone] || [];
    const geos = [shopify, cloudflare].filter(c => /^[A-Z]{2}$/.test(c || '') && !['XX','T1'].includes(c));
    let target;
    if (geos.length === 2 && geos[0] === geos[1] && (!tz.length || tz.includes(geos[0]))) target = geos[0];
    else if (tz.length === 1 && geos.includes(tz[0])) target = tz[0];
    if (target && offered(target)) return {action:target === current ? 'keep' : 'switch',country:target,reason:'corroborated'};
    // Weak or contradictory evidence can suggest a country, never silently choose one.
    const suggestion = (tz.length === 1 && offered(tz[0]) && tz[0]) || geos.find(offered) || current;
    return {action:'ask',country:suggestion,reason:geos.length ? 'uncertain' : 'unavailable'};
  }
  if (typeof module === 'object' && module.exports) { module.exports = {decide, zones, VERSION}; return; }
  const configNode = document.getElementById('rdc-market-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const available = config.countries.map(c => c.code);
  const ttl = 15 * 60 * 1000;
  let timeZone = '';
  try { timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone; } catch {}
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const cookie = key => document.cookie.split(';').map(v => v.trim()).find(v => v.startsWith(key+'='))?.slice(key.length+1);
  const fresh = (item, age) => item && Date.now()-item.ts >= 0 && Date.now()-item.ts < age;
  function remember(country) {
    document.cookie = 'rdc_country_manual_v1='+country+';path=/;max-age=2592000;SameSite=Lax;Secure';
    document.cookie = 'rdc_lang=manual;path=/;max-age=31536000;SameSite=Lax;Secure';
  }
  // Capture before ordinary form navigation, including browsers that block sessionStorage.
  document.addEventListener('submit', event => {
    if (event.target.id !== 'rdc-country-form') return;
    const country = event.target.querySelector('[name="country_code"]')?.value;
    if (available.includes(country)) remember(country);
  }, true);
  function showChoice(country) {
    if (document.getElementById('rdc-market-choice')) return;
    const bar = document.createElement('aside');
    bar.id = 'rdc-market-choice'; bar.setAttribute('aria-label', config.text.title);
    bar.style.cssText = 'position:relative;z-index:30;background:#f5f5f3;color:#171717;padding:12px 20px;display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:10px;font:14px/1.4 inherit;border-bottom:1px solid #ddd';
    const label = document.createElement('label'); label.textContent = config.text.title; label.htmlFor='rdc-market-choice-country';
    const select = document.createElement('select'); select.id='rdc-market-choice-country'; select.className='rdc-select'; select.style.width='auto';
    config.countries.forEach(item => {const o=document.createElement('option');o.value=item.code;o.textContent=item.name+' · '+item.currency;o.selected=item.code===country;select.append(o);});
    const apply = document.createElement('button');apply.type='button';apply.className='rdc-btn rdc-btn--secondary';apply.textContent=config.text.apply;
    apply.addEventListener('click', async () => {remember(select.value);apply.disabled=true; const ok=await switchCountry(select.value,true);if(!ok)apply.disabled=false;});
    const keep = document.createElement('button');keep.type='button';keep.className='rdc-btn rdc-btn--secondary';keep.textContent=config.text.keep;
    keep.addEventListener('click', () => {remember(config.country);bar.remove();});
    bar.append(label,select,apply,keep);document.body.prepend(bar);
  }
  async function switchCountry(country, manual=false) {
    if (!available.includes(country)) return false;
    if (country === config.country) { document.getElementById('rdc-market-choice')?.remove();return false; }
    const attempt = read('rdc_market_attempt_v1');
    const attemptedCookie = cookie('rdc_market_attempt_v1');
    if (!manual && (fresh(attempt,120000) || attemptedCookie)) {showChoice(country);return false;}
    write('rdc_market_attempt_v1',{country,ts:Date.now()});
    document.cookie='rdc_market_attempt_v1='+country+';path=/;max-age=120;SameSite=Lax;Secure';
    root.RDCMarketSwitching = true;
    const body = new FormData();
    body.set('form_type','localization');body.set('utf8','✓');body.set('_method','put');
    body.set('country_code',country);body.set('locale_code',config.language);
    body.set('return_to',location.pathname+location.search+location.hash);
    try {
      const controller = new AbortController();const timer=setTimeout(()=>controller.abort(),4000);
      let response;try {response=await fetch('/localization',{method:'POST',body,credentials:'same-origin',signal:controller.signal});} finally {clearTimeout(timer);}
      if (!response.ok || !response.redirected) throw new Error('localization');
      const dest = new URL(response.url);
      if (dest.origin !== location.origin) throw new Error('origin');
      // Fetch strips fragments, preserve the visitor's anchor explicitly.
      dest.hash=location.hash;
      location.replace(dest.href);return true;
    } catch {root.RDCMarketSwitching=false;showChoice(country);return false;}
  }
  async function getJSON(url, credentials) {
    const controller = new AbortController(); const timer=setTimeout(()=>controller.abort(),2500);
    try {const r=await fetch(url,{credentials,cache:'no-store',signal:controller.signal,referrerPolicy:'no-referrer'});if(!r.ok)throw 0;return await r.json();}
    finally {clearTimeout(timer);}
  }
  async function run() {
    if (/bot|crawl|spider|slurp|lighthouse|pagespeed|headless|preview|facebookexternalhit|embed|whatsapp|telegram/i.test(navigator.userAgent)) return {hold:false};
    const manual = cookie('rdc_country_manual_v1');
    const cached = read('rdc_market_verified_v1');
    if (available.includes(manual)) {
      const changed = manual !== config.country;
      if(changed)await switchCountry(manual);
      return {hold:changed};
    }
    if (fresh(cached,ttl) && cached.country===config.country && cached.timeZone===timeZone) return {hold:false};
    const results = await Promise.allSettled([
      getJSON('/browsing_context_suggestions.json?country[enabled]=true','same-origin'),
      getJSON(config.endpoint,'omit')
    ]);
    const shopify = results[0].status==='fulfilled' ? results[0].value.detected_values?.country?.handle : null;
    const cloudflare = results[1].status==='fulfilled' ? results[1].value.country : null;
    // A visitor can choose a country while the network checks are in flight.
    if (available.includes(cookie('rdc_country_manual_v1'))) return {hold:true};
    const result = decide({current:config.country,shopify,cloudflare,timeZone,available});
    // A DOM status is useful for support without storing or exposing network addresses.
    configNode.dataset.verification=result.reason;configNode.dataset.detectedCountry=result.country;
    if(result.action==='switch') {await switchCountry(result.country);return {hold:true};}
    if(result.action==='ask') {showChoice(result.country);return {hold:true};}
    if(result.reason==='corroborated') write('rdc_market_verified_v1',{country:config.country,timeZone,ts:Date.now()});
    return {hold:false};
  }
  root.RDCMarketReady = run().catch(()=>({hold:false}));
})(typeof window === 'object' ? window : this);
